var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#858585"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7587 4.24725C10.557 4.04557 10.2313 4.04557 10.0296 4.24725L7.50089 6.77078L4.97219 4.24208C4.77051 4.0404 4.44473 4.0404 4.24305 4.24208C4.04138 4.44375 4.04138 4.76954 4.24305 4.97121L6.77175 7.49991L4.24305 10.0286C4.04138 10.2303 4.04138 10.5561 4.24305 10.7577C4.44473 10.9594 4.77051 10.9594 4.97219 10.7577L7.50089 8.22905L10.0296 10.7577C10.2313 10.9594 10.557 10.9594 10.7587 10.7577C10.9604 10.5561 10.9604 10.2303 10.7587 10.0286L8.23002 7.49991L10.7587 4.97121C10.9552 4.77471 10.9552 4.44375 10.7587 4.24725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircle);
export default __webpack_public_path__ + "static/media/icon-close--circle.af4127986db12b06e9dd51cfea705e51.svg";
export { ForwardRef as ReactComponent };